/**
 * Copyright (c) 2025 Répét Contributors
 * Licensed under the MIT License
 * See LICENSE file in the project root for full license text
 */

/**
 * Calcule le hachage SHA-256 d'une chaîne de caractères.
 * Utilise l'API Web Crypto pour une exécution asynchrone et non-bloquante.
 *
 * @param str - La chaîne à hacher.
 * @returns Une promesse qui se résout avec le hachage hexadécimal.
 */
export async function getHash(str: string): Promise<string> {
  // Encoder la chaîne en un tableau d'octets (Uint8Array) en UTF-8
  const encoder = new TextEncoder()
  const data = encoder.encode(str)

  // Calculer le hachage avec l'API SubtleCrypto
  const hashBuffer = await crypto.subtle.digest('SHA-256', data)

  // Convertir le buffer de hachage en un tableau d'octets
  const hashArray = Array.from(new Uint8Array(hashBuffer))

  // Convertir chaque octet en sa représentation hexadécimale
  const hashHex = hashArray.map((b) => b.toString(16).padStart(2, '0')).join('')

  return hashHex
}
